// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import invEntity from './entities/inv.json';
import invMenu from '../pages/inv/menu.json';
import invFullForm from '../pages/inv/forms/full.json';
import invContextForm from '../pages/inv/forms/context.json';
import invMiniForm from '../pages/inv/forms/mini.json';
import invLookupForm from '../pages/inv/forms/lookup.json';
import invTableView from '../pages/inv/views/table.json';
import invStagesView from '../pages/inv/views/stages.json';
import invCardsView from '../pages/inv/views/cards.json';
import invInlineView from '../pages/inv/views/inline.json';
import invBacklogView from '../pages/inv/views/backlog.json';
import invSplitView from '../pages/inv/views/split.json';
import invCalendarView from '../pages/inv/views/calendar.json';
import invDashboardView from '../pages/inv/views/dashboard.json';

/** Тип запису «Розслідування» зі сторінками пакета: меню, форми та подання з pages/inv/. */
export const invDefinition: IRecordTypeDefinition = {
  ...invEntity,
  views: assembleViewSet({
      table: invTableView,
      stages: invStagesView,
      cards: invCardsView,
      inline: invInlineView,
      backlog: invBacklogView,
      split: invSplitView,
      calendar: invCalendarView,
      dashboard: invDashboardView,
  }),
  form: invFullForm,
  forms: { full: invFullForm, context: invContextForm, mini: invMiniForm, lookup: invLookupForm },
  menu: invMenu,
} as IRecordTypeDefinition;
